import * as React from 'react';
import { useEffect, useState } from 'react';
import { getPageProperties } from '../../../services/cps-school-api';
import { getAvailabilityColor } from '../../../utility/api-utilities';

export interface IAdmissionsTabProps {
    school: any // Marking this as any because the api response is huge and prone to changing
}

function AdmissionsTab({ school }: IAdmissionsTabProps) {
    
    const checkButton = (program) => {
        if (program.DisplayButton == 'Yes') {
            const date = new Date(program.ApplicationDeadline);
            if (date < (new Date())) {
                return <a className="btn" target="_blank" href="https://cps.schoolmint.com">Apply Now</a>
            }
        }
        return program.ApplicationDeadline
    }

    // do this with state, or another way? maybe just load props into global context
    const [applyButtonText, setApplyButtonText] = useState<string>(null);
    /*const setTableHeight = () => {
        const admitionsTables = document.getElementsByClassName('additional-program-table');
        console.log('admitionsTables: ', admitionsTables);
        if (admitionsTables.length > 0) {
            for (let i = 0; i < admitionsTables.length; i++) {
                console.log('!!! scrollHeight: ', admitionsTables[i].scrollHeight)
                admitionsTables[i]['style']['height'] = `${admitionsTables[i].scrollHeight}px`
            }
        }
    }*/
    useEffect(() => {
        getPageProperties().then(props => setApplyButtonText(props.applyButtonText));
       // school.programs[0].hsatMathPercentMin = '111'
    }, []);
 
    const checkString = (data): boolean => {
        if (data && data.toLowerCase() !== 'none' && data.toLowerCase() !== 'n/a') {
            return true;
        }
        return false;
    }
    const checkMultipleFields = (fields: []) => {
       return fields.some( i => i && i !== "")
    }
    const queueList = (data: string) => {
        if (data && data.split(',').length > 0) {
            return data.split(',').map((i, index) => <li key={`queueItem_${index}`}>{i}</li>)
        } else { return null; } 
    }
    return <div className="admissions-tab profile-section">
        <div className="header">
            <h2>Program Application Requirements</h2>
        </div>
        {school.programs.length > 0 ? <></> : <p>There are no program application requirements available.</p>}

        {school._prek && school._prek.Programs && school._prek.Programs.map(program => <div key={program.programType} className="program-listing">
            <h3>{school.schoolShortName} - Pre-K</h3>
            <div className="table-scrolling-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Program Name</th>
                            <th>Ages</th>
                            <th>School Day</th>
                            <th>Availability</th>
                            <th>Application Opens</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{program.ProgramName}</td>
                            <td>{program.AcceptedGrades.split(',').map(g => <div key={g}>{g}</div>)}</td>
                            <td>{program.CategoryName}</td>
                            <td><span className={`circle ${getAvailabilityColor(program.Availability)}`}></span> {program.Availability}</td>
                            <td>{checkButton(program)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>)
        }

        {school.programs.map(program => <div key={program.programType} className="program-listing">
            <h3>{program.programType}</h3>
            <div className="table-scrolling-wrapper">
                <table cellPadding="0" cellSpacing="0" width="100%" className="additional-program-table">
                    <thead>
                        <tr>
                            <th>Overview</th>
                            <th>Application and Selection Details</th>
                            <th>Previous Application Cycle Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                
                                {!school.isHighSchool  && <p><span className="adTable-title">Grades Served:</span> <span>{program.programGradesServed ? program.programGradesServed : 'N/A'}</span></p>}
                                {program.programOverview && <p>{program.programOverview}</p>}
                            </td>
                            <td className="padding-0 position-relative">
                                <div className="table-details-container">
                                    <div className="table-details-col">
                                        <p><span className="adTable-title">Additional Screening:</span> <span dangerouslySetInnerHTML={{ __html: program.programApplicationRequirements ? program.programApplicationRequirements : 'N/A'}}></span></p>
                                        <p><span className="adTable-title">Selection Type: </span>{program.subPrograms ? program.subPrograms : 'N/A' }</p>
                                    </div>
                                    <div className="table-details-col">
                                        <p><span className="adTable-title">Minimum GPA Requirement:</span> <span dangerouslySetInnerHTML={{ __html: program.gpa ? program.gpa : 'N/A' }}></span></p>
                                        {school.isHighSchool && program.assessmentDescription && <p><span className="adTable-title mb-0">HS Admissions Test Requirement: </span> {program.assessmentDescription}  </p> }
                                    </div>
                                    <div className="table-details-col">
                                        <div><span className="adTable-title">Queue Priorities:</span>
                                            {program.priority ? <ol key="queue_list">{queueList(program.priority)}</ol> : 'N/A' }
                                        </div>
                                        
                                        {(program.notes && program.notes !== "") && <p><span className="adTable-title">Notes: </span> {program.notes}</p>}

                                    </div>
                                </div> 
                            </td>
                            <td>
                                <p>
                                    <span className="adTable-title">Number of Applicants:</span> {program.previousYearApplicationCount ? program.previousYearApplicationCount : 'N/A'}
                                </p>
                                <p>
                                    <span className="adTable-title">Number of offers: </span> {program.previousYearOfferCount ? program.previousYearOfferCount : 'N/A'}
                                </p>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>           
        </div>)}
        <div className="program-key">
            <h3>Key</h3>
            <div><em>(Non-PreK)</em></div>
            <ul>
                <li><strong>GPA: </strong> All GPA requirements are for students applying to grades 5-9. All K-4 programs have NO GPA requirements. </li>
                <li><strong>Selection by Point: </strong> See HS Scoring Rubrics and ES Scoring Rubrics on the GoCPS Resource pages for specific point breakdown.</li>
                <li><strong>Queue Priorities: </strong> See the HS Explore and ES Explore sections on the GoCPS website to learn more about specific priorities. </li>
                <li><strong>HS Admissions Exam Minimum: </strong> Minimum % required in order for applicant to be included in the Selections process. </li>
            </ul>
        </div>
    </div>
}

export default AdmissionsTab;